/**
 * Assets configuration file
 * 
 * Centralizes all static asset paths for the portfolio application.
 * This approach provides:
 * - Type safety for asset references
 * - Single source of truth for asset paths
 * - Easy maintenance and updates
 * - Import optimization through bundler
 */

/**
 * Asset paths configuration object
 * Contains relative paths to all static assets used in the application
 * Note: Assets should be placed in the public/assets directory for Vite to serve them
 */
const BASE_URL = import.meta.env.BASE_URL || '/';

export const assets = {
  // Favicon for browser tab
  favicon: `${BASE_URL}assets/favicon.png`,
  
  // Brand logo
  logo: `${BASE_URL}assets/logo.png`,
  
  // Profile/avatar image (WebP format for optimal performance)
  profile_picture: `${BASE_URL}assets/profile_picture.webp`,
  
  cv_pdf: `${BASE_URL}assets/Nugitha-Disas-CV.pdf`,
  
  // Project images
  projects: {
    petpulse: `${BASE_URL}assets/projects/pp.png`,
    plantNursery: `${BASE_URL}assets/projects/plant-ner.png`,
    whatsappBot: `${BASE_URL}assets/projects/whatsapp-bot.svg`,
    libraryManagement: `${BASE_URL}assets/projects/booklib.png`,
    chatApp: `${BASE_URL}assets/projects/web-chat.png`,
    mosBurgers: `${BASE_URL}assets/projects/mosBurgers.png`,
    docWise: `${BASE_URL}assets/projects/DocWise.png`,
    ims: `${BASE_URL}assets/projects/ims.png`,
    polkole: `${BASE_URL}assets/projects/polkole.png`,
  }
} as const; // 'as const' provides literal type inference for better TypeScript support
